// extracted by mini-css-extract-plugin
module.exports = {"pszauan":"pszauan","tej3rqq":"tej3rqq","p10qe7zq":"p10qe7zq"};